const CLIENT_PORT = 3000;
const SERVER_PORT = 80;
export default {
    CLIENT_FOLDER: "www",
    SERVER_FOLDER: "server",
    CLIENT_PORT,
    SERVER_PORT,
    SERVER:
        process.env.NODE_ENV === "production"
            ? `http://viewer.bimatter.ru:${SERVER_PORT}`
            : `http://localhost:${SERVER_PORT}`,
    CLIENT:
        process.env.NODE_ENV === "production"
            ? `http://viewer.bimatter.ru:${CLIENT_PORT}`
            : `http://localhost:${CLIENT_PORT}`,
};
